/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

const { isMobile } = require('./helpers/born.utils');
const { hasTouch } = require('./util');

var countries = require('./countries'),
    dialog = require('./dialog'),
    minicart = require('./minicart'),
    page = require('./page'),
    // rating = require('./rating'),
    // searchplaceholder = require('./searchplaceholder'),
    searchsuggest = require('./searchsuggest'),
    // tooltip = require('./tooltip'),
    util = require('./util'),
    validator = require('./validator'),
    tls = require('./tls'),
    bornModules = require('./helpers/born.modules').default,
    productTile = require('./product-tile'),
    eventlanding = require('./pages/eventlanding'),
    popupArabicVersionPromotion = require('./popup-helper.js'),
    recaptcha = require('./recaptcha'),
    lazyPictureLoad = require('./lazypictureload'),
    lazyLoadVideo = require('./lazyloadvideo');

// if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');
    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
    s.setAttribute('type', 'text/javascript');
    document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./cookieprivacy')();
require('./captcha')();

function initializeEvents() {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    /** Initialize arabic site version promotion pop-up close button */
    popupArabicVersionPromotion();
    
    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length,
                charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).parent().find('.char-remain-count').html(charsRemain);
        });

    /**
     * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
     * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
     * */
    
    searchsuggest.init(util.isMobiles() ? '.js-mobile-search' : '#navigation .header-search', Resources.SIMPLE_SEARCH);

    // add show/hide navigation elements
    // $('.secondary-navigation .toggle').click(function () {
    //     $(this).toggleClass('expanded').next('ul').toggle();
    // });

    // add generic toggle functionality
    // $('.toggle').next('.toggle-content').hide();
    // $('.toggle').click(function () {
    //     $(this).toggleClass('expanded').next('.toggle-content').toggle();
    // });

    // subscribe email box
    // var $subscribeEmail = $('.subscribe-email');
    // if ($subscribeEmail.length > 0)    {
    //     $subscribeEmail.focus(function () {
    //         var val = $(this.val());
    //         if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
    //             return; // do not animate when contains non-default value
    //         }

    //         $(this).animate({color: '#999999'}, 500, 'linear', function () {
    //             $(this).val('').css('color', '#333333');
    //         });
    //     }).blur(function () {
    //         var val = $.trim($(this.val()));
    //         if (val.length > 0) {
    //             return; // do not animate when contains value
    //         }
    //         $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
    //             .css('color', '#999999')
    //             .animate({color: '#333333'}, 500, 'linear');
    //     });
    // }

    eventlanding.init();

    $('.privacy-policy').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                height: 600
            }
        });
    });

    // main menu toggle
    $('.menu-toggle').on('click', function () {
        $('#wrapper').toggleClass('menu-active');
    });
    $('.menu-category li .menu-item-toggle').on('click', function (e) {
        e.preventDefault();
        var $parentLi = $(e.target).closest('li');
        $parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa-chevron-up active').addClass('fa-chevron-right');
        $parentLi.toggleClass('active');
        $(e.target).toggleClass('fa-chevron-right fa-chevron-up active');
    });
    $('.user-account').on('click', function (e) {
        e.preventDefault();
        $(this).parent('.user-info').toggleClass('active');
    });

    $(document).on('recommendationsLoad', function () {
        bornModules.carousel.init();
        bornModules.productRating.init();
        if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
            const lazyLoadConfig = { preloadExpandBy: 100 };
            lazyPictureLoad.init(lazyLoadConfig);
        }
    }).trigger('recommendationListenerReady');

    lazyLoadVideo.init();

    $(document).on('productTileRatingLoad', function() {
        bornModules.productRating.init();
    });
    
    $(document).on('lazyhomepictureloadLoad', function() {
        if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
            let lazyConfig = { observerId: 'homepage', preloadExpandBy: 100 };
            lazyPictureLoad.init(lazyConfig);
        }
    });
    $(document).on('lazyPictureLoad', function () {
        if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
            const lazyLoadConfig = { preloadExpandBy: 500 , breakPointMobile:576};
            lazyPictureLoad.init(lazyLoadConfig);
        }
    });
}
/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (!util.isMobile() && SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }
    // load js specific styles
    util.limitCharacters();
}

var pages = {
    account: require('./pages/account'),
    cart: require('./pages/cart'),
    checkout: require('./pages/checkout'),
    // compare: require('./pages/compare'),
    product: require('./pages/product'),
    // registry: require('./pages/registry'),
    search: require('./pages/search'),
    storefront: require('./pages/storefront'),
    wishlist: require('./pages/wishlist'),
    signuppage: require('./pages/signuppage'),
    subscribersignuppage: require('./pages/subscribersignuppage'),
    orderconfirmation: require('./pages/checkout/orderconfirmation'),
    subscriberconfirmation: require('./pages/subscriberconfirmation'),
    brandcampaign: require('./pages/brandcampaign'),
    magazine: require('./pages/magazine'),
    storelocator: require('./pages/storelocator'),
    bookappointment:require('./pages/bookappointment'),
    storeqr: require('./pages/storeqr'),
    bloghome: require('./pages/blog/index')
};

// Remove hover styles for IOS mobile devices to avoid the tap initiates hover issue
function removeHoverForIOS() {
    if (window.innerWidth < 768 && isMobile.iOS()) {

        if (hasTouch()) { // remove all the :hover stylesheets
            try { // prevent exception on browsers not supporting DOM styleSheets properly
              for (var si in document.styleSheets) {
                var styleSheet = document.styleSheets[si];
                    if (styleSheet.rules) {
                        for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                            if (!styleSheet.rules[ri].selectorText) continue;

                            if (styleSheet.rules[ri].selectorText.match(':hover')) {
                                styleSheet.deleteRule(ri);
                            }
                        }
                    } else if (styleSheet.cssRules) {
                        for (var ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
                            if (!styleSheet.cssRules[ri].selectorText) continue;

                            if (styleSheet.cssRules[ri].selectorText.match(':hover')) {
                                styleSheet.deleteRule(ri);
                            }
                        }
                    }
                }
            } catch (ex) {}
        }
    }
}

function checkoutSignInPopup() {
    $(document).on('click', '.checkout-btn', function() {
        sessionStorage.setItem('showSignInModal', 'true');
    })
}


var app = {
    init: function () {
        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }
        initializeDom();
        initializeEvents();

        // init specific global components
        countries.init();
        // tooltip.init();
        minicart.init();
        validator.init();
        productTile.init();
        recaptcha.init();
        // rating.init();
        // searchplaceholder.init();
        // execute page specific initializations
        $.extend(page, window.pageContext);
        var ns = page.ns;
        if (ns && pages[ns] && pages[ns].init) {   
            pages[ns].init();
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }
        
        var countryCode = $("#currentCountryCode").val();
        if(countryCode != null){
        	$("#currentCountry").val(countryCode);
        }
        removeHoverForIOS();
        checkoutSignInPopup()
    }
};

// general extension functions
(function () {
    String.format = function () {
        var s = arguments[0];
        var i, len = arguments.length - 1;
        for (i = 0; i < len; i++) {
            var reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    };
})();

// initialize app
$(document).ready(function () {
    app.init();
});



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/app.js